module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Thompson_C.32b4c220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_Thompson_C.png
// module id = 244
// module chunks = 0